import {
  ChakraProvider as BaseChakraProvider,
  ChakraProviderProps as BaseChakraProviderProps,
} from '@chakra-ui/provider';
import { theme as defaultTheme } from '@sj/sj-theme';
import {
  ToastProvider,
  ToastProviderProps,
  ToastOptionProvider,
} from '@chakra-ui/toast';

export interface ChakraProviderProps extends BaseChakraProviderProps {
  /**
   * Provide defaults for `useToast()` usages for `ChakraProvider`s children
   */
  toastOptions?: ToastProviderProps;
}

const createChakraProvider = (providerTheme: any) =>
  // eslint-disable-next-line react/function-component-definition,no-shadow
  function ChakraProvider({
    children,
    theme = providerTheme,
    toastOptions,
    ...restProps
  }: ChakraProviderProps) {
    return (
      <BaseChakraProvider theme={theme} {...restProps}>
        <ToastOptionProvider value={toastOptions?.defaultOptions}>
          {children}
        </ToastOptionProvider>
        <ToastProvider {...toastOptions} />
      </BaseChakraProvider>
    );
  };

export const ChakraProvider = createChakraProvider(defaultTheme);
